// import '../App.css';
// import logo from '../assets/images/service-logo.png';
// import adult from '../assets/images/adult.png';
// import children from '../assets/images/children.png';
// import shave from '../assets/images/shave.png';
// import design from '../assets/images/design.png';
// import hair from '../assets/images/hair.png';
// import unisex from '../assets/images/unisex.png';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import '../App.css';

function Services() {
  const [acf, setAcf] = useState(null);
  const [services, setServices] = useState([]);
  const [showBooking, setShowBooking] = useState(false);

  useEffect(() => {
    axios
      .get("https://family-barbers.com/wp-json/acf/v3/pages/14") // replace with your actual page ID
      .then((res) => {
        const data = res.data.acf;
        setAcf(data);

        // Build service array dynamically
        setServices([
          { title: data.service_1_title, description: data.service_1_description, icon: data.service_1_icon },
          { title: data.service_2_title, description: data.service_2_description, icon: data.service_2_icon },
          { title: data.service_3_title, description: data.service_3_description, icon: data.service_3_icon },
          { title: data.service_4_title, description: data.service_4_description, icon: data.service_4_icon },
          { title: data.service_5_title, description: data.service_5_description, icon: data.service_5_icon },
          { title: data.service_6_title, description: data.service_6_description, icon: data.service_6_icon },
        ]);
      })
      .catch((err) => console.error("Error fetching services:", err));
  }, []);

  if (!acf) return null;

  return (
    <div id="services" className="section"
      style={{
        backgroundImage: acf?.services_background_image
          ? `url(${acf.services_background_image.url})`
          : "none",
      }}
    >
      <div className='service-parent-container'>
        {/* Section Logo */}
        <motion.div
          initial={{ x: 400, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {acf.services_logo && <img src={acf.services_logo.url} alt="barbershop logo colored" className='service-logo' />}
        </motion.div>

        {/* Headings */}
        <div className='underline service-underline'></div>
        <motion.h1
          initial={{ x: -400, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >{acf.services_h1}</motion.h1>
        <h3>{acf.services_h3}</h3>

        {/* Services */}
        <div className='service-child-container'>
          {services
            .filter(service => service.title || service.description || service.icon)
            .map((service, index) => (
              <div className='service-child' key={index}>
                <div>
                  {service.icon && <img src={service.icon.url} alt={service.title || `Service ${index + 1}`} />}
                </div>
                <div>
                  {service.title && <h2>{service.title}</h2>}
                  {service.description && <p dangerouslySetInnerHTML={{ __html: service.description }} />}
                </div>
              </div>
            ))}
        </div>

        {/* Book Now Button */}
        {acf.services_button_text && acf.services_button_url && (
          <a href={acf.services_button_url} className='book-now button-service-section'>
            {acf.services_button_text}
          </a>
        )}
        <motion.button
          initial={{ x: -200, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="book-now"
          onClick={() => {
            if (window.innerWidth < 1024) {
              // On small screens, go straight to booking page
              window.open("https://getsquire.com/booking/brands/family-barbers", "_blank");
            } else {
              // On desktop, toggle the popup modal
              setShowBooking(!showBooking);
            }
          }}
        >
          <span>{acf.about_button_text || "BOOK NOW!"}</span>
        </motion.button>

        {/* Booking Popup */}
        {showBooking && (
          <div className="booking-modal">
            <div className="booking-content">
              <button className="close-btn" onClick={() => setShowBooking(!showBooking)}>
                ✖
              </button>
              <iframe
                src="https://getsquire.com/booking/brands/family-barbers"
                style={{ width: "100%", height: '95vh', border: "none" }}
                title="Squire Booking"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Services;
